import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//import ClientSlider from '../components/ClientSlider';
import { IMAGES 
  // , SVGICON 
} from '../constants/theme';
//import LatestSlider from '../elements/LatestSlider';
import NewsLetter from '../elements/NewsLetter';
import PageTitle from '../elements/PageTitle';
//import WorkoutSlider from '../elements/WorkoutSlider';

const wrapperBlog = [
  { title: "Right Nutrition", image: IMAGES.boxlog1, description: "Discover personalized nutrition plans tailored to your health goals and lifestyle needs." },
  { title: "Health & Fitness", image: IMAGES.boxlog2, description: "Comprehensive wellness programs combining exercise, nutrition, and healthy living strategies." },
  { title: "Gym & Exercise", image: IMAGES.boxlog3, description: "Expert-guided workout routines and training programs to help you achieve your fitness goals." },
  { title: "Health Motivation", image: IMAGES.boxlog4, description: "Inspirational coaching and support to keep you motivated on your health journey." },
  { title: "Healthy Heart", image: IMAGES.boxlog5, description: "Specialized cardiovascular health programs designed to strengthen your heart and improve circulation." },
  { title: "Smoothie & Juice", image: IMAGES.boxlog6, description: "Nutritious recipes and meal plans featuring fresh smoothies and juices for optimal health." },
];

const Services = () => {
  const [hover, setHover] = useState(0);

  return (
    <>
      <div className="page-content bg-white">
        <PageTitle activePage="Services" parentTitle="Services" />

        <section
          className="content-inner overflow-hidden"
          style={{ backgroundImage: "url(" + IMAGES.BgImage1 + ")" }}
        >
          <div className="container">
            <div className="row">

              {wrapperBlog.map((item, index) => (
                <div className="col-xl-4 col-md-6 m-b30" key={index}>
                  <div
                    className={`icon-bx-wraper style-1 box-hover ${
                      hover === index ? "active" : ""
                    }`}
                    onMouseEnter={() => setHover(index)}
                  >
                    <div className="icon-bx m-b30">
                      <span className="icon-cell">
                        <img src={item.image} alt="" />
                      </span>
                    </div>

                    <div className="icon-content">
                      <h5 className="dz-title m-b10">
                        <Link to={"#"}>{item.title}</Link>
                      </h5>
                      <p className="m-b25">
                        {item.description}
                      </p>

                      <Link
                        to={"/services-details"}
                        className="btn btn-primary shadow-primary btn-skew"
                      >
                        <span>Read More</span>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </section>

        <section className="call-action style-1 footer-action">
          <div className="container">
            <NewsLetter />
          </div>
        </section>
      </div>
    </>
  );
};

export default Services;
